import { render, staticRenderFns } from "./OffersDropdown.vue?vue&type=template&id=f3077720"
import script from "./OffersDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./OffersDropdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OffersDropdown.vue?vue&type=style&index=0&id=f3077720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports